export default __webpack_public_path__ + "static/media/flight-icon.5d8b3fed.svg";